import React, { useState } from 'react';
import { PHOTO_PATH } from '../constants';


const TALUKAS = {
  Ahmednagar: ['Akole', 'Jamkhed', 'Karjat', 'Kopargaon', 'Nagar', 'Nevasa', 'Parner', 'Pathardi', 'Rahata', 'Rahuri', 'Sangamner', 'Shevgaon', 'Shrigonda', 'Shrirampur'],
  Akola: ['Akola', 'Akot', 'Balapur', 'Barshitakli', 'Murtizapur', 'Patur', 'Telhara'],
  Amravati: ['Achalpur', 'Amravati', 'Anjangaon Surji', 'Bhatkuli', 'Chandurbazar', 'Chikhaldara', 'Daryapur', 'Dhamangaon Railway', 'Dharni', 'Morshi', 'Nandgaon Khandeshwar', 'Teosa', 'Warud'],
  Beed: ['Ambajogai', 'Ashti', 'Beed', 'Dharur', 'Georai', 'Kaij', 'Majalgaon', 'Parli', 'Patoda', 'Shirur Kasar', 'Wadwani'],
  Bhandara: ['Bhandara', 'Lakhandur', 'Lakhani', 'Mohadi', 'Pauni', 'Sakoli', 'Tumsar'],
  Buldhana: ['Buldhana', 'Chikhli', 'Deulgaon Raja', 'Jalgaon Jamod', 'Khamgaon', 'Lonar', 'Malkapur', 'Mehkar', 'Motala', 'Nandura', 'Sangrampur', 'Shegaon', 'Sindkhed Raja'],
  Chandrapur: ['Ballarpur', 'Bhadravati', 'Brahmapuri', 'Chandrapur', 'Chimur', 'Gondpipri', 'Jiwati', 'Korpana', 'Mul', 'Nagbhir', 'Pombhurna', 'Rajura', 'Sawali', 'Sindewahi', 'Warora'],
  'Chhatrapati Sambhajinagar': ['Aurangabad', 'Gangapur', 'Kannad', 'Khultabad', 'Paithan', 'Phulambri', 'Sillod', 'Soegaon', 'Vaijapur'],
  Dhule: ['Dhule', 'Sakri', 'Shirpur', 'Sindkhede'],
  Gadchiroli: ['Aheri', 'Armori', 'Bhamragad', 'Chamorshi', 'Desaiganj', 'Dhanora', 'Etapalli', 'Gadchiroli', 'Korchi', 'Kurkheda', 'Mulchera', 'Sironcha'],
  Gondia: ['Amgaon', 'Arjuni Morgaon', 'Deori', 'Gondia', 'Goregaon', 'Sadak Arjuni', 'Salekasa', 'Tirora'],
  Hingoli: ['Hingoli', 'Kalamnuri', 'Sengaon', 'Basmat', 'Aundha Nagnath'],
  Jalgaon: ['Amalner', 'Bhadgaon', 'Bhusawal', 'Bodwad', 'Chalisgaon', 'Chopda', 'Dharangaon', 'Erandol', 'Jalgaon', 'Jamner', 'Muktainagar', 'Pachora', 'Parola', 'Raver', 'Yawal'],
  Jalna: ['Ambad', 'Badnapur', 'Bhokardan', 'Ghansawangi', 'Jafrabad', 'Jalna', 'Mantha', 'Partur'],
  Kolhapur: ['Ajara', 'Bhudaragad', 'Chandgad', 'Gadhinglaj', 'Gaganbawada', 'Hatkanangle', 'Kagal', 'Karveer', 'Panhala', 'Radhanagari', 'Shahuwadi', 'Shirol'],
  Latur: ['Ahmedpur', 'Ausa', 'Chakur', 'Deoni', 'Jalkot', 'Latur', 'Nilanga', 'Renapur', 'Shirur Anantpal', 'Udgir'],
  Nagpur: ['Hingna', 'Kalameshwar', 'Kamptee', 'Katol', 'Kuhi', 'Mouda', 'Nagpur Rural', 'Nagpur Urban', 'Narkhed', 'Parseoni', 'Ramtek', 'Saoner', 'Umred'],
  Nanded: ['Ardhapur', 'Bhokar', 'Biloli', 'Degloor', 'Dharmabad', 'Hadgaon', 'Himayatnagar', 'Kandhar', 'Kinwat', 'Loha', 'Mahur', 'Mudkhed', 'Mukhed', 'Nanded', 'Naigaon', 'Umri'],
  Nandurbar: ['Akkalkuwa', 'Akrani', 'Nandurbar', 'Navapur', 'Shahada', 'Taloda'],
  Nashik: ['Baglan', 'Chandwad', 'Deola', 'Dindori', 'Igatpuri', 'Kalwan', 'Malegaon', 'Nandgaon', 'Nashik', 'Niphad', 'Peint', 'Sinnar', 'Surgana', 'Trimbakeshwar', 'Yeola'],
  Osmanabad: ['Bhoom', 'Kalamb', 'Lohara', 'Omerga', 'Osmanabad', 'Paranda', 'Tuljapur', 'Washi'],
  Palghar: ['Dahanu', 'Jawhar', 'Mokhada', 'Palghar', 'Talasari', 'Vasai', 'Vikramgad', 'Wada'],
  Parbhani: ['Parbhani', 'Gangakhed', 'Jintur', 'Manwath', 'Pathri', 'Purna', 'Palam', 'Sonpeth', 'Selu'],
  Pune: ['Ambegaon', 'Baramati', 'Bhor', 'Daund', 'Haveli', 'Indapur', 'Junnar', 'Khed', 'Maval', 'Mulshi', 'Pune City', 'Purandar', 'Shirur', 'Velhe'],
  Raigad: ['Alibag', 'Karjat', 'Khalapur', 'Mahad', 'Mangaon', 'Mhasala', 'Murud', 'Panvel', 'Pen', 'Poladpur', 'Roha', 'Shrivardhan', 'Sudhagad', 'Tala', 'Uran'],
  Ratnagiri: ['Chiplun', 'Dapoli', 'Guhagar', 'Khed', 'Lanja', 'Mandangad', 'Rajapur', 'Ratnagiri', 'Sangameshwar'],
  Sangli: ['Atpadi', 'Jat', 'Kadegaon', 'Kavathemahankal', 'Khanapur', 'Miraj', 'Palus', 'Shirala', 'Tasgaon', 'Walwa'],
  Satara: ['Jaoli', 'Karad', 'Khandala', 'Koregaon', 'Mahabaleshwar', 'Man', 'Patan', 'Phaltan', 'Satara', 'Wai'],
  Sindhudurg: ['Devgad', 'Dodamarg', 'Kankavli', 'Kudal', 'Malvan', 'Sawantwadi', 'Vaibhavwadi', 'Vengurla'],
  Solapur: ['Akkalkot', 'Barshi', 'Karmala', 'Madha', 'Malshiras', 'Mangalwedha', 'Mohol', 'Pandharpur', 'Sangola', 'Solapur North', 'Solapur South'],
  Thane: ['Ambernath', 'Bhiwandi', 'Kalyan', 'Murbad', 'Shahapur', 'Thane', 'Ulhasnagar'],
  Wardha: ['Arvi', 'Ashti', 'Deoli', 'Hinganghat', 'Karanja', 'Samudrapur', 'Seloo', 'Wardha'],
  Washim: ['Karanja', 'Malegaon', 'Mangrulpir', 'Manora', 'Risod', 'Washim'],
  Yavatmal: ['Babhulgaon', 'Darwha', 'Digras', 'Ghatanji', 'Kalamb', 'Kelapur', 'Mahagaon', 'Maregaon', 'Ner', 'Pusad', 'Ralegaon', 'Umarkhed', 'Wani', 'Yavatmal', 'Zari Jamani']
};

const DISTRICTS = [
  { value: 'Ahmednagar', label: 'Ahmednagar / अहमदनगर' },
  { value: 'Akola', label: 'Akola / अकोला' },
  { value: 'Amravati', label: 'Amravati / अमरावती' },
  { value: 'Beed', label: 'Beed / बीड' },
  { value: 'Bhandara', label: 'Bhandara / भंडारा' },
  { value: 'Buldhana', label: 'Buldhana / बुलढाणा' },
  { value: 'Chandrapur', label: 'Chandrapur / चंद्रपूर' },
  { value: 'Chhatrapati Sambhajinagar', label: 'Chhatrapati Sambhajinagar / छत्रपती संभाजीनगर' },
  { value: 'Dhule', label: 'Dhule / धुळे' },
  { value: 'Gadchiroli', label: 'Gadchiroli / गडचिरोली' },
  { value: 'Gondia', label: 'Gondia / गोंदिया' },
  { value: 'Hingoli', label: 'Hingoli / हिंगोली' },
  { value: 'Jalgaon', label: 'Jalgaon / जळगाव' },
  { value: 'Jalna', label: 'Jalna / जालना' },
  { value: 'Kolhapur', label: 'Kolhapur / कोल्हापूर' },
  { value: 'Latur', label: 'Latur / लातूर' },
  { value: 'Nagpur', label: 'Nagpur / नागपूर' },
  { value: 'Nanded', label: 'Nanded / नांदेड' },
  { value: 'Nandurbar', label: 'Nandurbar / नंदुरबार' },
  { value: 'Nashik', label: 'Nashik / नाशिक' },
  { value: 'Osmanabad', label: 'Osmanabad (Dharashiv) / उस्मानाबाद (धाराशिव)' },
  { value: 'Palghar', label: 'Palghar / पालघर' },
  { value: 'Parbhani', label: 'Parbhani / परभणी' },
  { value: 'Pune', label: 'Pune / पुणे' },
  { value: 'Raigad', label: 'Raigad / रायगड' },
  { value: 'Ratnagiri', label: 'Ratnagiri / रत्नागिरी' },
  { value: 'Sangli', label: 'Sangli / सांगली' },
  { value: 'Satara', label: 'Satara / सातारा' },
  { value: 'Sindhudurg', label: 'Sindhudurg / सिंधुदुर्ग' },
  { value: 'Solapur', label: 'Solapur / सोलापूर' },
  { value: 'Thane', label: 'Thane / ठाणे' },
  { value: 'Wardha', label: 'Wardha / वर्धा' },
  { value: 'Washim', label: 'Washim / वाशिम' },
  { value: 'Yavatmal', label: 'Yavatmal / यवतमाळ' }
];

const initialForm = {
  kutumbKramank: '',
  sadasyaKramank: '',
  district: '',
  taluka: '',
  village: '',
  mobile: '',
  aadhaarNumber: '',
  arjKramank: '',
  aaplaArjKramank: '',
  kamgarPrakar: '',
  anubhaviVarsh: '',
  kutumbSadasya: '',
  kamgarName: '',
};

function RegistrationForm({ onSubmit, onCancel, API }) {
  const [form, setForm] = useState(initialForm);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [submitError, setSubmitError] = useState('');
  const [duplicate, setDuplicate] = useState(null);
  const [checkingDuplicate, setCheckingDuplicate] = useState(false);

  const kamgarOptions = ['Purush Kamgar / पुरुष कामगार', 'Mahila Kamgar / महिला कामगार'];
  const anubhaviOptions = Array.from({ length: 15 }, (_, i) => `${i + 1} Year${i > 0 ? 's' : ''}`);

  const validate = () => {
    const errs = {};
    if (!form.kutumbKramank.trim()) errs.kutumbKramank = 'Required / आवश्यक';
    if (!form.sadasyaKramank.trim()) errs.sadasyaKramank = 'Required / आवश्यक';
    if (!form.kamgarName.trim()) errs.kamgarName = 'Required / आवश्यक';
    if (!form.district) errs.district = 'Required / आवश्यक';
    if (!form.taluka) errs.taluka = 'Required / आवश्यक';
    if (!form.village.trim()) errs.village = 'Required / आवश्यक';
    if (!form.mobile.trim()) errs.mobile = 'Required / आवश्यक';
    else if (!/^\d{10}$/.test(form.mobile.trim())) errs.mobile = 'Enter valid 10-digit number / वैध 10-अंकी क्रमांक प्रविष्ट करा';
    if (!form.aadhaarNumber.trim()) errs.aadhaarNumber = 'Required / आवश्यक';
    else if (!/^\d{12}$/.test(form.aadhaarNumber.trim())) errs.aadhaarNumber = 'Enter valid 12-digit Aadhaar / वैध 12-अंकी आधार प्रविष्ट करा';
    if (!form.arjKramank.trim()) errs.arjKramank = 'Required / आवश्यक';
    if (!form.kamgarPrakar) errs.kamgarPrakar = 'Required / आवश्यक';
    if (!form.anubhaviVarsh) errs.anubhaviVarsh = 'Required / आवश्यक';
    return errs;
  };

  const checkDuplicate = async (kutumbKramank, aadhaarNumber) => {
    if (!kutumbKramank && !aadhaarNumber) return;
    setCheckingDuplicate(true);
    try {
      const res = await fetch(`${API}/registration/check-duplicate`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({
          kutumbKramank: kutumbKramank ? kutumbKramank : '',
          aadhaarNumber,
        }),
      });
      const data = await res.json();
      if (data.duplicate) {
        setDuplicate(data.existing);
      } else {
        setDuplicate(null);
      }
    } catch {
      // silently fail - don't block the user
    } finally {
      setCheckingDuplicate(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'district') {
      setForm((prev) => ({ ...prev, district: value, taluka: '' }));
    } else if (name === 'aadhaarNumber') {
      if (value === '' || /^\d{0,12}$/.test(value)) {
        setForm((prev) => ({ ...prev, aadhaarNumber: value }));
      }
    } else {
      setForm((prev) => ({ ...prev, [name]: value }));
    }
    if (errors[name]) setErrors((prev) => ({ ...prev, [name]: '' }));
    if (duplicate) setDuplicate(null);
  };

  const handleBlur = (name) => {
    if (name === 'kutumbKramank' || name === 'aadhaarNumber') {
      const kutumb = name === 'kutumbKramank' ? form.kutumbKramank.trim() : form.kutumbKramank.trim();
      const aadhaar = name === 'aadhaarNumber' ? form.aadhaarNumber.trim() : form.aadhaarNumber.trim();
      if ((name === 'kutumbKramank' && kutumb) || (name === 'aadhaarNumber' && aadhaar)) {
        checkDuplicate(kutumb, aadhaar);
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitError('');
    const errs = validate();
    if (Object.keys(errs).length > 0) {
      setErrors(errs);
      return;
    }
    if (duplicate) {
      setSubmitError('This Kutumb Kramank / Aadhaar is already registered. Please check the details above. / हा कुटुंब क्रमांक / आधार आधीच नोंदणीकृत आहे. कृपया वरील तपशील तपासा.');
      return;
    }
    setLoading(true);
    try {
      await onSubmit({
        ...form,
        kutumbKramank: form.kutumbKramank,
        kamgarPrakar: form.kamgarPrakar.replace(' / पुरुष कामगार', '').replace(' / महिला कामगार', ''),
      });
    } catch (err) {
      setSubmitError(err.message || 'Submission failed / सबमिशन अयशस्वी');
    } finally {
      setLoading(false);
    }
  };

  const talukaList = form.district ? TALUKAS[form.district] || [] : [];

  const field = (label, name, type = 'text', required = true) => (
    <div className="form-group">
      <label>
        {label} {required && <span className="required-star">*</span>}
      </label>
      <input
        type={type}
        name={name}
        value={form[name]}
        onChange={handleChange}
        onBlur={() => handleBlur(name)}
        placeholder={`Enter ${label.split(' (')[0].toLowerCase()}`}
      />
      {errors[name] && <div className="field-error">{errors[name]}</div>}
    </div>
  );

  return (
    <div className="form-card">
      <div className="form-header">
        <img
          src={PHOTO_PATH}
          alt="Gopinath Munde"
          className="form-photo"
        />
        <div>
          <h2>New Registration / नवीन नोंदणी</h2>
          <p className="form-desc">Fill in the details below. Fields marked with * are mandatory.<br />खाली तपशील भरा. * चिन्हांकित फील्ड आवश्यक आहेत.</p>
        </div>
      </div>

      {submitError && <div className="error-msg">{submitError}</div>}

      {duplicate && (
        <div className="duplicate-warning">
          <strong>Duplicate Found / डुप्लिकेट आढळले!</strong>
          <p>This Kutumb Kramank / Aadhaar is already registered with the following details:</p>
          <ul>
            <li><strong>Kutumb Kramank:</strong> {duplicate.kutumbKramank}</li>
            <li><strong>Sadasya Kramank:</strong> {duplicate.sadasyaKramank}</li>
            <li><strong>Kamgar Name:</strong> {duplicate.kamgarName}</li>
            <li><strong>District:</strong> {duplicate.district}</li>
            <li><strong>Taluka:</strong> {duplicate.taluka}</li>
            <li><strong>Village:</strong> {duplicate.village}</li>
            <li><strong>Mobile:</strong> {duplicate.mobile}</li>
            <li><strong>Aadhaar:</strong> {duplicate.aadhaarNumber}</li>
            <li><strong>Arj Kramank:</strong> {duplicate.arjKramank}</li>
            <li><strong>Kamgar Prakar:</strong> {duplicate.kamgarPrakar}</li>
            <li><strong>Anubhavi Varsh:</strong> {duplicate.anubhaviVarsh}</li>
          </ul>
          <p className="duplicate-hint">Please verify before submitting a duplicate. / कृपया डुप्लिकेट सबमिट करण्यापूर्वी पडताळून घ्या.</p>
        </div>
      )}

      {checkingDuplicate && <p className="checking-text">Checking existing records...</p>}

      <form onSubmit={handleSubmit}>
        <div className="form-row">
          <div className="form-group">
            <label>
              Kutumb Kramank (कुटुंब क्रमांक) <span className="required-star">*</span>
            </label>
            <div className="prefix-input-group">
              <input
                type="text"
                name="kutumbKramank"
                value={form.kutumbKramank}
                onChange={handleChange}
                onBlur={() => handleBlur('kutumbKramank')}
                placeholder="Enter remaining number"
                style={{ paddingLeft: 8 }}
              />
            </div>
            {errors.kutumbKramank && <div className="field-error">{errors.kutumbKramank}</div>}
          </div>
          {field('Sadasya Kramank (सदस्य क्रमांक)', 'sadasyaKramank')}
        </div>

        <div className="form-row">
          {field('Kamgar Name (कामगार नाव)', 'kamgarName')}
          <div className="form-group">
            <label>
              District (जिल्हा) <span className="required-star">*</span>
            </label>
            <select name="district" value={form.district} onChange={handleChange}>
              <option value="">Select District / जिल्हा निवडा</option>
              {DISTRICTS.map((d) => (
                <option key={d.value} value={d.value}>{d.label}</option>
              ))}
            </select>
            {errors.district && <div className="field-error">{errors.district}</div>}
          </div>

          <div className="form-group">
            <label>
              Taluka (तालुका) <span className="required-star">*</span>
            </label>
            <select name="taluka" value={form.taluka} onChange={handleChange} disabled={!form.district}>
              <option value="">Select Taluka / तालुका निवडा</option>
              {talukaList.map((t) => (
                <option key={t} value={t}>{t}</option>
              ))}
            </select>
            {errors.taluka && <div className="field-error">{errors.taluka}</div>}
          </div>
        </div>

        <div className="form-row">
          {field('Village (गाव)', 'village')}
          {field('Mobile Number (मोबाईल क्रमांक)', 'mobile', 'number')}
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>
              Aadhaar Number (आधार क्रमांक) <span className="required-star">*</span>
            </label>
            <input
              type="text"
              name="aadhaarNumber"
              value={form.aadhaarNumber}
              onChange={handleChange}
              onBlur={() => handleBlur('aadhaarNumber')}
              placeholder="Enter 12-digit Aadhaar / 12-अंकी आधार प्रविष्ट करा"
              maxLength={12}
              inputMode="numeric"
            />
            {errors.aadhaarNumber && <div className="field-error">{errors.aadhaarNumber}</div>}
          </div>
          {field('Arj Kramank (अर्ज क्रमांक)', 'arjKramank')}
        </div>

        <div className="form-row">
          {field('Aapla Arj Kramank (आपला अर्ज क्रमांक)', 'aaplaArjKramank', 'text', false)}
          <div className="form-group">
            <label>
              Kamgar Prakar (कामगार प्रकार) <span className="required-star">*</span>
            </label>
            <select name="kamgarPrakar" value={form.kamgarPrakar} onChange={handleChange}>
              <option value="">Select / निवडा</option>
              {kamgarOptions.map((opt) => (
                <option key={opt} value={opt}>{opt}</option>
              ))}
            </select>
            {errors.kamgarPrakar && <div className="field-error">{errors.kamgarPrakar}</div>}
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>
              Anubhavi Varsh (अनुभवी वर्ष) <span className="required-star">*</span>
            </label>
            <select name="anubhaviVarsh" value={form.anubhaviVarsh} onChange={handleChange}>
              <option value="">Select / निवडा</option>
              {anubhaviOptions.map((opt) => (
                <option key={opt} value={opt}>{opt}</option>
              ))}
            </select>
            {errors.anubhaviVarsh && <div className="field-error">{errors.anubhaviVarsh}</div>}
          </div>
          {field('Kutumb Sadasya (कुटुंब सदस्य)', 'kutumbSadasya', 'text', false)}
        </div>

        <div className="form-actions">
          <button type="submit" className="btn-primary" disabled={loading || checkingDuplicate}>
            {loading ? 'Submitting... / सबमिट करत आहे...' : 'Submit Registration / नोंदणी सबमिट करा'}
          </button>
          <button type="button" className="btn-secondary" onClick={onCancel}>
            Cancel / रद्द करा
          </button>
        </div>
      </form>
    </div>
  );
}

export default RegistrationForm;
